import { render } from "./EnEditableDataFieldsViewSection.vue?vue&type=template&id=3b52f664&scoped=true"
import script from "./EnEditableDataFieldsViewSection.vue?vue&type=script&setup=true&lang=js"
export * from "./EnEditableDataFieldsViewSection.vue?vue&type=script&setup=true&lang=js"

import "./EnEditableDataFieldsViewSection.vue?vue&type=style&index=0&id=3b52f664&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b52f664"],['__file',"Shared/components/forms/EnEditableDataFieldsViewSection/EnEditableDataFieldsViewSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b52f664"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b52f664', __exports__)) {
    api.reload('3b52f664', __exports__)
  }
  
  module.hot.accept("./EnEditableDataFieldsViewSection.vue?vue&type=template&id=3b52f664&scoped=true", () => {
    api.rerender('3b52f664', render)
  })

}


export default __exports__